import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.XeroAmaxPayBatchPaymentRequestCard.MenuCell', {
    cancel: 'Cancel',
    transactionDetails: 'Show transaction details',
});
